/**
 * Single reader for profile module grants.
 * After 0150, profiles must have `grants` — no `moduleIds` fallback.
 */
export function grantsOf(profile) {
    return profile.grants ?? [];
}
//# sourceMappingURL=moduleGrants.js.map